const tileServer = 'https://tiles.ju60.de';

export const config = {
  apiUrl: '',
  localStoragePrefix: 'otb::',
  darkMapStyle: `${tileServer}/styles/gray-matter/style.json`,
  brightMapStyle: `${tileServer}/styles/bright-matter/style.json`,
};
